import mixins from 'vue-typed-mixins';

import KeystrokeInputableTextMixin from '@/entries/user/mixins/KeystrokeInputableTextMixin';

import { MONTHS_OF_YEAR } from '@/classes/common/Constants';
import { PlbscfListItem, PlbscfYearItem } from '@/classes/service/AbstractPlbscfService';
import { ValueType } from '@/master/Plbscf';

export type PlbscfInputableTextId = {
  listItemIndex: number;
  yearIndex?: number;
  monthIndex?: number;
};

export default mixins(KeystrokeInputableTextMixin).extend({
  name: 'PlbscfKeystrokeInputableTextMixin',

  computed: {
    // 各画面で上書き
    map(): PlbscfInputableTextId[][] {
      return [];
    },
  },

  methods: {
    createMap(list: PlbscfListItem[], readonlyMonthIndex: number | null = null): PlbscfInputableTextId[][] {
      const map: PlbscfInputableTextId[][] = [];
      list.forEach((listItem, listItemIndex) => {
        const ids = this.$_addListItemIds(listItem, listItemIndex, readonlyMonthIndex);
        if (ids.length > 0) map.push(ids);
      });
      return map;
    },
    addYearIds(
      ids: (PlbscfInputableTextId | null)[],
      listItemIndex: number,
      yearItems: PlbscfYearItem[],
      readonlyMonthIndex: number | null = null,
      isNull = false
    ): void {
      yearItems.forEach((yi, yearIndex) => {
        if (yi.type !== undefined) return;
        if (yi.withMonths) {
          for (let monthIndex = 0; monthIndex < MONTHS_OF_YEAR; monthIndex++) {
            if (readonlyMonthIndex === null || monthIndex > readonlyMonthIndex)
              ids.push(isNull ? null : { listItemIndex, yearIndex, monthIndex });
          }
        } else {
          ids.push(isNull ? null : { listItemIndex, yearIndex });
        }
      });
    },
    setFirstId(): void {
      this.setFirstKeystrokeId(this.map);
    },
    $_addListItemIds(
      listItem: PlbscfListItem,
      listItemIndex: number,
      readonlyMonthIndex: number | null = null
    ): PlbscfInputableTextId[] {
      const ids: PlbscfInputableTextId[] = [];
      if ([ValueType.勘定科目, ValueType.calcValue].includes(listItem.config.valueType)) {
        this.addYearIds(ids, listItemIndex, listItem.yearValues, readonlyMonthIndex);
      }
      return ids;
    },
  },
});
